import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import { Input } from '@/components/common/form/input'
import { PageHeader } from '@/components/common/navigation/PageHeader'
import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form'
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { UsuarioService } from '@/features/usuarios/services/usuario.service'

const ResetPasswordDialog = ({ onClose }: { onClose: () => void }) => {
  const { user } = useAuthStore()

  const form = useForm({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  })

  const onSubmit = form.handleSubmit(async (data) => {
    if (!user) return toast.error('Usuário não encontrado')

    const { password, confirmPassword } = data
    if (password !== confirmPassword) return toast.error('Senhas não conferem')

    try {
      await UsuarioService.changePassword({
        id: user.id,
        password: data.password,
      })
      onClose()
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  })

  return (
    <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
      <Form {...form}>
        <form onSubmit={onSubmit} className="flex h-full flex-col">
          <SheetHeader>
            <SheetTitle>Reiniciar senha</SheetTitle>
          </SheetHeader>

          <div className="flex flex-1 flex-col gap-4 py-4">
            <Input
              field_control={form.control}
              field_name="password"
              field_label="Nova senha"
              input_type="password"
            />

            <Input
              field_control={form.control}
              field_name="confirmPassword"
              field_label="Confirmar nova senha"
              input_type="password"
            />
          </div>

          <SheetFooter>
            <Button type="submit">Enviar</Button>
          </SheetFooter>
        </form>
      </Form>
    </SheetContent>
  )
}

export default function Component() {
  const { user } = useAuthStore()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <PageHeader title="Minha página" />
      <div className="p-8">
        <p className="mb-8 text-xl">Bem-vindo {user?.displayName}</p>

        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetTrigger asChild>
            <Button>Alterar senha</Button>
          </SheetTrigger>
          <ResetPasswordDialog onClose={() => setIsOpen(false)} />
        </Sheet>
      </div>
    </>
  )
}
